import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { Platform, MenuController, App} from 'ionic-angular';
import { ServiceProvider } from '../../providers/service/service';
import { Storage } from '@ionic/storage';
import { AlertController, Nav, ToastController, LoadingController } from 'ionic-angular';

import { HomePage } from '../home/home';
import {DataProgressPage} from "../data-progress/data-progress";
import {EnquiryPage} from "../enquiry/enquiry";
import {AdmissionPage} from "../admission/admission";
import {AppointmentsPage} from "../appointments/appointments";
import {GuestPage} from "../guest/guest";
import {FeedbackPage} from "../feedback/feedback";
import {DemoPaginationPage} from "../demo-pagination/demo-pagination";
import {WhtspPage} from "../whtsp/whtsp";
import {FeesPage} from "../fees/fees";
import {ErpAdmissionPage} from "../erp-admission/erp-admission";
import {ContactPage} from "../contact/contact";
import {DailyLogsPage} from "../daily-logs/daily-logs";
import {CallEnquiryReminderPage} from "../call-enquiry-reminder/call-enquiry-reminder";
import {DataProcessModulePage} from "../data-process-module/data-process-module";
import {SchoolEnquiryPage} from "../school-enquiry/school-enquiry";
import {CommunicationPage} from "../communication/communication";

@Component({
  selector: 'page-dashboard-home',
  templateUrl: 'dashboard-home.html',
})
export class DashboardHomePage {

  tab1Root=DataProgressPage;
  tab2Root=CallEnquiryReminderPage;
  tab3Root=DataProcessModulePage;
  tab4Root=HomePage;
  tab5Root=DailyLogsPage;
  tab6Root=CommunicationPage;


  // tab1Root = HomePage;
  // // tab1Root = DemoPaginationPage;
  // tab2Root = DataProcessModulePage;
  // tab3Root = SchoolEnquiryPage;
  // tab4Root = DataProgressPage;
  // tab5Root = AdmissionPage;
  // tab6Root = AppointmentsPage;
  // tab7Root = GuestPage;
  // tab8Root = FeedbackPage;
  // tab9Root = WhtspPage;
  // tab10Root = FeesPage;
  // tab11Root = ErpAdmissionPage;
  // tab12Root = ContactPage;
  // tab13Root = DailyLogsPage;
  // tab14Root = CallEnquiryReminderPage;

  FUserTypeId:any;
  FUserId:any;
  UserRights:any;
  School:any;



  constructor(public navCtrl: NavController, public navParams: NavParams, public service: ServiceProvider, public platform:Platform, menuCtrl:MenuController, public loadingCtrl: LoadingController, public toastCtrl: ToastController,
              public storage: Storage,
              public _app: App) {
    this.platform.ready().then(() => {
      Promise.all([this.storage.get('LoginData')]).then(values => {
       this.FUserId = values[0]['FUserId'];
       console.log(this.FUserId);
       this.get_user_rights(this.FUserId);
      });
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DashboardHomePage');
  }
  get_user_rights(FUserId){
   this.service.httpcall('web_service/get_users_rights?FUserId='+FUserId).subscribe(data => {
     console.log(data['RightsData']);
     this.UserRights = data['RightsData'];
     for(var i=0;i<this.UserRights.length;i++){

     }
     if(this.UserRights != undefined){
      console.log(this.School)
      //this.loadvalues(this.SchoolData[this.School],this.TypeData[this.AllType],this.FUserId);
    }
    // console.log("this.UserRights -> ",this.UserRights.All.Admission)
   })
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard-home/dashboard-home.ts